/* eslint-disable */
import * as Store from '@apply/store';
import { useNavigate } from 'react-router-dom';
import { useAuthentication } from '../../../LoginPage';
import { alertModal } from '@apply/ui';
import { FeatureType } from '@apply/constants';
import { BusinessAndPeopleApi } from '@apply/api';
import { applicationInsights } from '../../../ApplicationInsights';
import { connect } from 'react-redux';
import { ApplyThunkDispatch } from '@apply/store/src/utils';

const CreateNewApplicationButton = ({ dispatch }: { dispatch: ApplyThunkDispatch }) => {
    const businessAndPeopleApi = new BusinessAndPeopleApi.BusinessAndPeopleApi(applicationInsights);
    const navigate = useNavigate();
    const { isFeatureEnabled } = useAuthentication();
    const redirectBorrower = `/borrower`;

    const { Actions } = Store.BorrowerStore;

    const loadUserBusinesses = async () => {
        try {
            const responseBusinesses = await businessAndPeopleApi.getBorrowerBusinesses();
            if (responseBusinesses.statusCode !== 200) {
                alertModal({
                    message: 'Failed to load Borrower Business Information. Please try again.',
                });
            }

            let result = responseBusinesses.result;
            if (result && result.length == 0) {
                navigate(`/business?redirectTo=/borrower`);
            } else {
                navigate(redirectBorrower);
            }
        } catch (ex) {
            alertModal({
                message: 'Failed to load Borrower Entities. Please try again.',
            });
        }
    };

    const onNewApplication = () => {
        // BFIA-4083 Wipe the apiId so we do not accidently reuse the same appliation. We want a new one.
        dispatch(Actions.updateApiId(''));

        //Check if feature flag is enabled
        if (!isFeatureEnabled(FeatureType.BPHierarchyPhase1)) {
            navigate(redirectBorrower);
        } else {
            //Check to see if a top level business exists
            loadUserBusinesses();
        }
    };

    return (
        <div>
            Create a
            <button
                className='button gridActionColumnButton'
                style={{ marginLeft: 5 }}
                onClick={onNewApplication}
            >
                New Application
            </button>
        </div>
    );
};

export const mapStateToProps = () => () => {
    return {};
};

export const mapDispatchToProps = (dispatch: Store.ApplyDispatchType) => {
    const props: { dispatch: Store.ApplyDispatchType } = {
        dispatch,
    };
    return props;
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateNewApplicationButton);
